import React from "react";
import { ReporteDePago, MontoVencido } from "../../../services/v2/portalAlumno.service";

/** "L 3,000.00" / "$1,850.00 MXN". */
export const dinero = (monto: number, simbolo: string): string =>
	simbolo + monto.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export const Dinero: React.FC<{ m: MontoVencido }> = ({ m }) => (
	<>{dinero(m.amount, m.symbol)} <small className="ptMoneda">{m.currency}</small></>
)

/** Lista "Ya Lo Reporté": folio, fecha y estado (En Revisión / Aplicado / Rechazado). */
export const ListaDeReportes: React.FC<{ reportes: ReporteDePago[] }> = ({ reportes }) => (
	<div className="ptReportes">
		{reportes.length === 0
			? <div className="ptVacio">Aún No Has Reportado Pagos</div>
			: reportes.map((r) => (
				<div className="ptReporte" key={r.id}>
					<span className="ptReporteFolio">#{r.id}</span>
					<span className="ptReporteFecha">{r.createdLabel}</span>
					<span className={"ptEstado ptEstado-" + r.status}>{r.statusLabel}</span>
				</div>
			))}
	</div>
)
